module.exports = __webpack_public_path__ + "static/img/brand.cab52ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/brand.png
// module id = YeCo
// module chunks = 1